import { Suspense } from 'react'
import { createFileRoute } from '@tanstack/react-router'
import { Loader } from '@/shared/ui/loader'
import { BloodCollectionTab } from '@pages/donor-detail/ui/BloodCollectionTab'

function BloodCollectionRoute() {
  const { visitId } = Route.useParams()
  return (
    <Suspense fallback={<Loader />}>
      <BloodCollectionTab visitId={visitId} />
    </Suspense>
  )
}

export const Route = createFileRoute(
  '/_protected/labarotaroyResearch/$visitId/blood-collection',
)({
  component: BloodCollectionRoute,
})
